<template>
  <div class="d-flex align-center justify-center mt-5" v-if="loading">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </div>
</template>

<script>
import {httpsCallable} from "firebase/functions";
import {functions} from "@/assets/utils/firebase.utils";

export default {
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    async copyLetter() {
      const vm = this;
      try {
        let id = vm.$route.params.id;
        // Query values arrive as strings: "false" must not count as print.
        let print = String(vm.$route.query.print) == "true";
        let manageLetter = httpsCallable(functions, "manageLetter");
        let { faxId, fax_pdf_url } = (
          await manageLetter({ action: "copy", data: { id, print } })
        ).data;
        vm.loading = false;
        if (fax_pdf_url && print == true) {
          window.open(fax_pdf_url, "_blank");
          if (this.$route.query.customerId) {
            vm.$router.replace(
              `/dispute-letters/${this.$route.query.customerId}`
            );
          } else {
            vm.$router.replace("/dispute-letters");
          }
        } else {
          vm.$router.replace(`/edit-send-letter/${faxId}`);
        }
      } catch (error) {
        vm.$router.back();
        vm.notifyError(error.message);
      }
    },
  },
  mounted() {
    this.copyLetter();
  },
};
</script>

<style></style>
